import ReactDOM from "react-dom";
import { Snackbar as Snack } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import type { AlertProps, Color } from "@material-ui/lab/Alert";
import { useGlobalStyles } from "./globalStyles";
import type { SnackbarProps } from "./types";

const SEVERITY_CLASS_KEY: Record<Color, string> = {
  success: "snackbarAlertSuccess",
  error: "snackbarAlertError",
  warning: "snackbarAlertWarning",
  info: "snackbarAlertInfo",
};

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="outlined" {...props} />;
}

export default function Snackbar(props: SnackbarProps) {
  const classes = useGlobalStyles() as Record<string, string>;
  const vertical = "bottom";
  const horizontal = "center";
  const severity = (props.severity as Color) || "success";

  return ReactDOM.createPortal(
    <Snack
      anchorOrigin={{ vertical, horizontal }}
      open
      onClose={props.handleClose}
      key={vertical + horizontal}
      autoHideDuration={props.disableAutoHide ? null : 5000}
      className={props.isModal ? classes.snackbarPositionCss : undefined}
    >
      <Alert
        onClose={props.handleClose}
        severity={severity}
        className={`${classes.snackbarAlert} ${classes[SEVERITY_CLASS_KEY[severity]]}`}
      >
        {props.message}
      </Alert>
    </Snack>,
    document.body
  );
}
